"use strict";
/**
 * Types shared between Cerberus (Rust) and aven_backend (TypeScript).
 * These types are auto-translated to Rust via translateToRust.js.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CerberusRecommendedAction = exports.CerberusDecision = void 0;
/** @TranslateToRust */
var CerberusDecision;
(function (CerberusDecision) {
    CerberusDecision["allowed"] = "ALLOWED";
    CerberusDecision["blocked"] = "BLOCKED";
    CerberusDecision["shadowBlocked"] = "SHADOW_BLOCKED";
})(CerberusDecision || (exports.CerberusDecision = CerberusDecision = {}));
/** @TranslateToRust */
var CerberusRecommendedAction;
(function (CerberusRecommendedAction) {
    CerberusRecommendedAction["blockAccount"] = "BlockAccount";
    CerberusRecommendedAction["none"] = "None";
})(CerberusRecommendedAction || (exports.CerberusRecommendedAction = CerberusRecommendedAction = {}));
